import React, {Fragment} from 'react';
import {Flex, Breadcrumbs, Layout, Button, Form, List, Separator, Edit} from 'components';
import {moment, useNamedSelector, useSelector} from "helpers";
import {WeeklyObjectiveCard} from "./weekly-objective-card";
import {goals} from 'store';

export function Start() {

  const { firstDayOfWeek } = useNamedSelector('settings.settings');
  moment.updateLocale('en', {
    week: {
      dow: firstDayOfWeek - 1 // 1 = Sunday, 2 = Monday
    }
  });
  const startOfWeek = moment().startOf('week');
  const endOfWeek = moment().endOf('week');

  const weeklyObjectives = useNamedSelector('goals.weeklyObjectives', {
    module: 'goals'
  });

  const filteredWeeklyObjectives = weeklyObjectives.filter(objective => {
    const targetDate = moment.unix(objective.target_date);
    return targetDate.isBetween(startOfWeek, endOfWeek, 'day', '[]');
  });

  let goal = useSelector((state) => goals.details(state, {id: -1, context: 'goals'}));

  const save = (form, { resetForm }) => {
    if (form.name && (form.name.trim() !== '')) {
      goal.name = form.name;
      goal.isWeeklyObjective = true;
      goal.target_date = moment(endOfWeek).startOf('day').unix();
      goals.dispatch.upsert({
        ...goal,
      });
    }
    resetForm({
      values: {
        name: ''
      }
    });
  };

  return (
    <>
      <Layout.Header>
        <Flex>
          <div className="pull-left">
            <Breadcrumbs>
              <b>Weekly Objectives</b>
            </Breadcrumbs>
          </div>
          <Button to="/today/" className={['small', 'borderless']} icon="return">Cancel</Button>
          <Button to="/today/plan-my-week/activities" className={['primary', 'small']} rightIcon="arrow-right">Next</Button>
        </Flex>
      </Layout.Header>
      <div className="sticky-container">
        <Form onSubmit={save} delay>
          <List tiny-gutter>
            <Fragment>
              <Flex className="medium-spacing">
                What do I want/need to accomplish this week? What are the most important results/outcomes I should focus on?
              </Flex>
              <Edit required name="name" placeholder={'Enter Weekly Objective here..'} />
              <Separator className="medium">
                <u/>
              </Separator>
            </Fragment>
          </List>
        </Form>
        <Layout.Sidebar.Scrollable>
          {filteredWeeklyObjectives.map(goal => goal.heading !== undefined
            ? <Separator key={goal.heading} heading={goal.heading}/>
            : <WeeklyObjectiveCard
                id={goal.id}
                key={goal.id}
                hideAddActivitiesButton={true}
              />
          )}
        </Layout.Sidebar.Scrollable>
      </div>
    </>
  )
}
